export interface CardsStatementState {
    cardsStatementData?: object;
    cardsAccountStatementData?: object;
    inProgress?: boolean;
    error?: any;
    notify?: boolean;
    filterData?: Array<any>;
    ccyName?: object;
    blocksByIban?: Array<any>;
    cardsData?: Array<any>;
    inProgressCards?: boolean;
    moreDetailData?: object;
    ibanNumber?:object;
    requisiteData?: object;
    cardLoading?: boolean;
    balanceLoading?: boolean;
    transferWidgetLoading?: boolean;
    type : string;
    cardArray:  Array<any>;
    accountArray: Array<any>;
    accountsData: Array<any>;
}

export enum CardStatementActionTypes {

    GET_CARDS_STATEMENT_REQUEST = 'GET_CARDS_STATEMENT_REQUEST',
    GET_CARDS_STATEMENT_SUCCESS = 'GET_CARDS_STATEMENT_SUCCESS',
    GET_CARDS_ACCOUNT_STATEMENT_SUCCESS = 'GET_CARDS_ACCOUNT_STATEMENT_SUCCESS',
    GET_CARDS_STATEMENT_ERROR = 'GET_CARDS_STATEMENT_ERROR',
    SET_CARDS_STATEMENT_FILTER = 'SET_CARDS_STATEMENT_FILTER',
    SET_CCY_NAME = 'SET_CCY_NAME',
    GET_BLOCKED_IBAN_REQUEST = 'GET_BLOCKED_IBAN_REQUEST',
    GET_BLOCKED_IBAN_SUCCESS = 'GET_BLOCKED_IBAN_SUCCESS',
    GET_BLOCKED_IBAN_ERROR = 'GET_BLOCKED_IBAN_ERROR',
    GET_CARDS_DATA_REQUEST = 'GET_CARDS_DATA_REQUEST',
    GET_CARDS_DATA_SUCCESS = 'GET_CARDS_DATA_SUCCESS',
    GET_CARDS_DATA_ERROR = 'GET_CARDS_DATA_ERROR',
    SET_MORE_DETAIL = 'SET_MORE_DETAIL',
    SET_IBAN_NUMBER = 'SET_IBAN_NUMBER',
    SET_CARDS_TYPE = 'SET_CARDS_TYPE',
    GET_REQUISITE_REQUEST = 'GET_REQUISITE_REQUEST',
    GET_REQUISITE_SUCCESS = 'GET_REQUISITE_SUCCESS',
    GET_REQUISITE_ERROR = 'GET_REQUISITE_ERROR',
    SET_CARD_LOADING = 'SET_CARD_LOADING',
    SET_BALANCE_LOADING = 'SET_BALANCE_LOADING',
    SET_TRANSFER_WIDGET_LOADING = 'SET_TRANSFER_WIDGET_LOADING',
    SET_CARD_ARRAY = 'SET_CARD_ARRAY',
    SET_CARD_ACCOUNTS_ARRAY = 'SET_CARD_ACCOUNTS_ARRAY',
    CLEAR_CARD_ARRAY = 'CLEAR_CARD_ARRAY'
}

interface SetCardsStatementRequestAction {
    type: CardStatementActionTypes.GET_CARDS_STATEMENT_REQUEST
}

interface SetCardsStatementSuccessAction {
    type: CardStatementActionTypes.GET_CARDS_STATEMENT_SUCCESS;
    payload: any;
}
interface SetCardsAccountStatementSuccessAction {
    type: CardStatementActionTypes.GET_CARDS_ACCOUNT_STATEMENT_SUCCESS;
    payload: any;
}

interface SetCardsStatementTypeAction{
    type: CardStatementActionTypes.SET_CARDS_TYPE;
    payload: any;
}
interface SetCardsStatementErrorAction {
    type: CardStatementActionTypes.GET_CARDS_STATEMENT_ERROR;
    error: any;
}

interface SetCardsStatementRefreshAction {
    type: CardStatementActionTypes.SET_CARDS_STATEMENT_FILTER;
    payload: any;
}

interface SetCCYNAMEAction {
    type: CardStatementActionTypes.SET_CCY_NAME;
    payload: any;
}

interface GetBlockedIbanRequestAction {
    type: CardStatementActionTypes.GET_BLOCKED_IBAN_REQUEST
}

interface GetBlockedIbanSuccessAction {
    type: CardStatementActionTypes.GET_BLOCKED_IBAN_SUCCESS;
    payload: any;
}

interface GetBlockedIbanErrorAction {
    type: CardStatementActionTypes.GET_BLOCKED_IBAN_ERROR;
    error: any;
}

interface SetCardsDataRequestAction {
    type: CardStatementActionTypes.GET_CARDS_DATA_REQUEST
}

interface SetCardsDataSuccessAction {
    type: CardStatementActionTypes.GET_CARDS_DATA_SUCCESS;
    payload: any;
}

interface SetCardsDataErrorAction {
    type: CardStatementActionTypes.GET_CARDS_DATA_ERROR;
    error: any;
}

interface SetMoreDetailAction {
    type: CardStatementActionTypes.SET_MORE_DETAIL;
    payload: any;
}

interface SetIbanNumberAction {
    type: CardStatementActionTypes.SET_IBAN_NUMBER;
    payload: any;
}

interface SetRequisiteRequestAction {
    type: CardStatementActionTypes.GET_REQUISITE_REQUEST
}

interface SetRequisiteSuccessAction {
    type: CardStatementActionTypes.GET_REQUISITE_SUCCESS;
    payload: any;
}

interface SetRequisiteErrorAction {
    type: CardStatementActionTypes.GET_REQUISITE_ERROR;
    error: any;
}

interface SetCardAction {
    type: CardStatementActionTypes.SET_CARD_LOADING;
    payload: any;
}

interface SetBalanceAction {
    type: CardStatementActionTypes.SET_BALANCE_LOADING;
    payload: any;
}

interface SetTransferWidgetAction {
    type: CardStatementActionTypes.SET_TRANSFER_WIDGET_LOADING;
    payload: any;
}

interface SetCardArray {
    type: CardStatementActionTypes.SET_CARD_ARRAY;
    payload: any;
}

interface SetCardAccountsArray {
    type: CardStatementActionTypes.SET_CARD_ACCOUNTS_ARRAY;
    payload: any;
}

interface ClearCardListAction {
    type: CardStatementActionTypes.CLEAR_CARD_ARRAY;
}

export type CardStatementAction =
    SetCardsStatementRequestAction |
    SetCardsStatementSuccessAction |
    SetCardsStatementErrorAction   |
    SetCardsStatementRefreshAction |
    SetCCYNAMEAction                  |
    GetBlockedIbanRequestAction       |
    GetBlockedIbanSuccessAction       |
    GetBlockedIbanErrorAction         |
    SetCardsDataRequestAction      |
    SetCardsDataSuccessAction      |
    SetCardsDataErrorAction        |
    SetMoreDetailAction               |
    SetIbanNumberAction               |
    SetCardsStatementTypeAction       |
    SetRequisiteRequestAction         |
    SetRequisiteSuccessAction         |
    SetRequisiteErrorAction           |
    SetCardAction                  |
    SetBalanceAction                  |
    SetTransferWidgetAction |
    SetCardArray |
    SetCardAccountsArray    |
    SetCardsAccountStatementSuccessAction |
    ClearCardListAction

